import React, { useState } from 'react';

import CarQuickEstimatesForm from '@zego/flows/quickEstimates/car/components/StandaloneCarQuickEstimates';
import ScooterQuickEstimatesForm from '@zego/flows/quickEstimates/scooter/components/StandaloneScooterQuickEstimates';
import { BREAKPOINTS, unit, white } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import VehicleChoiceInput from '@zego/components/promotions/VehicleChoiceInput';

function ScooterCarQuickEstimates(
  {
    padding = unit(4),
    marginLeft = -30,
    marginRight = -30,
    boxShadow = '0 1px 5px rgba(0, 0, 0, 0.15)',
    locationName = null,
    header,
    formSettings,
  },
  ref,
) {
  const [vehicleType, setVehicleType] = useState('Scooter');
  return (
    <div
      css={{
        boxShadow: boxShadow,
        backgroundColor: white,
        padding: padding,
        marginLeft: marginLeft,
        marginRight: marginRight,
        [BREAKPOINTS.small]: {
          borderRadius: unit(1),
          margin: 0,
          padding: padding,
          marginLeft: marginLeft,
          marginRight: marginRight,
        },
      }}
      id="scooter-car-qe-form"
      ref={ref}
    >
      {header}
      <VehicleChoiceInput
        value={vehicleType}
        onChange={event => setVehicleType(event.target.value)}
        choices={['Scooter', 'Car']}
      />
      <Spacer height={unit(3)} />
      {vehicleType === 'Scooter' ? (
        <ScooterQuickEstimatesForm
          locationName={locationName}
          {...formSettings}
        />
      ) : (
        <CarQuickEstimatesForm locationName={locationName} {...formSettings} />
      )}
    </div>
  );
}

export default React.forwardRef(ScooterCarQuickEstimates);
